import { createIcon } from './create-icon'

export const Watch = createIcon({
  displayName: 'Watch',
  paths: [
    'M512 128c-212.096 0-384 171.904-384 384s171.904 384 384 384c212.096 0 384-171.904 384-384s-171.904-384-384-384zM512 213.333c164.693 0 298.667 133.973 298.667 298.667s-133.973 298.667-298.667 298.667c-164.693 0-298.667-133.973-298.667-298.667s133.973-298.667 298.667-298.667zM512 341.333c-23.552 0-42.667 19.115-42.667 42.667v102.613c0 37.589 30.464 68.053 68.053 68.053h102.613c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-85.333v-85.333c0-23.552-19.115-42.667-42.667-42.667z'
  ]
})
